import { render, staticRenderFns } from "./EditorGroup.vue?vue&type=template&id=46f594ec&"
import script from "./EditorGroup.vue?vue&type=script&lang=js&"
export * from "./EditorGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports